namespace Matrix.Indexation {
    export interface FactIndexRorForm {
        IndexationProfileKey: Serenity.IntegerEditor;
        IndexKey: Serenity.IntegerEditor;
        BaseDate: Serenity.DateEditor;
        EffectiveDate: Serenity.DateEditor;
        SourceCode: Serenity.StringEditor;
        IndexRor: Serenity.DecimalEditor;
        PriceIndex: Serenity.DecimalEditor;
        IndexCurrency: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class FactIndexRorForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.FactIndexRor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FactIndexRorForm.init)  {
                FactIndexRorForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(FactIndexRorForm, [
                    'IndexationProfileKey', w0,
                    'IndexKey', w0,
                    'BaseDate', w1,
                    'EffectiveDate', w1,
                    'SourceCode', w2,
                    'IndexRor', w3,
                    'PriceIndex', w3,
                    'IndexCurrency', w2,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
